var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-5" }, [
    _c("form", { attrs: { "data-vv-scope": "perfilEmpresa" } }, [
      _c("div", { staticClass: "vx-row" }, [
        _c(
          "div",
          { staticClass: "vx-col w-1/4" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|validaRut",
                  expression: "'required|validaRut'"
                }
              ],
              staticClass: "w-full",
              attrs: {
                label: "RUT",
                maxlength: "10",
                name: "iut",
                readonly: "readonly"
              },
              model: {
                value: _vm.datos.iut,
                callback: function($$v) {
                  _vm.$set(_vm.datos, "iut", $$v)
                },
                expression: "datos.iut"
              }
            }),
            _vm.getError("rutReceptor") == "required"
              ? _c(
                  "span",
                  { staticClass: "text-danger text-sm form-error-message" },
                  [_vm._v("RUT es obligatorio")]
                )
              : _vm._e(),
            _vm.getError("rutReceptor") == "rut"
              ? _c(
                  "span",
                  { staticClass: "text-danger text-sm form-error-message" },
                  [_vm._v("Formato de RUT incorrecto")]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _c("div", { staticClass: "vx-row" }, [
        _c(
          "div",
          { staticClass: "vx-col md:w-1/4 mt-3" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|alpha_num",
                  expression: "'required|alpha_num'"
                }
              ],
              staticClass: "w-full",
              attrs: {
                label: "Cód. Actividad Económica",
                maxlength: "10",
                name: "acteco",
                min: "0"
              },
              model: {
                value: _vm.datos.acteco,
                callback: function($$v) {
                  _vm.$set(_vm.datos, "acteco", $$v)
                },
                expression: "datos.acteco"
              }
            }),
            _vm.getError("acteco")
              ? _c(
                  "span",
                  { staticClass: "text-danger text-sm form-error-message" },
                  [_vm._v("Cód. actividad económica es obligatorio")]
                )
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "vx-col md:w-1/4 mt-3" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|alpha_spaces",
                  expression: "'required|alpha_spaces'"
                }
              ],
              staticClass: "w-full",
              attrs: { label: "Giro", maxlength: "50", name: "giro", min: "0" },
              model: {
                value: _vm.datos.giro,
                callback: function($$v) {
                  _vm.$set(_vm.datos, "giro", $$v)
                },
                expression: "datos.giro"
              }
            }),
            _vm.getError("giro")
              ? _c(
                  "span",
                  { staticClass: "text-danger text-sm form-error-message" },
                  [_vm._v("Giro es obligatorio")]
                )
              : _vm._e()
          ],
          1
        ),
        _c("div", { staticClass: "vx-col md:w-2/6 mt-3" }, [
          _c(
            "div",
            {
              staticClass:
                "vs-component vs-con-input-label vs-input w-full vs-input-primary"
            },
            [
              _c(
                "label",
                {
                  staticClass: "vs-input--label",
                  attrs: { for: "fecharResolucion" }
                },
                [_vm._v("Fecha Resolución")]
              ),
              _c("datepicker", {
                attrs: {
                  id: "fechaResolucion",
                  name: "fechaResolucion",
                  required: ""
                },
                model: {
                  value: _vm.datos.fechaResolucion,
                  callback: function($$v) {
                    _vm.$set(_vm.datos, "fechaResolucion", $$v)
                  },
                  expression: "datos.fechaResolucion"
                }
              })
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "vx-col md:w-2/6 mt-3" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|numeric",
                  expression: "'required|numeric'"
                }
              ],
              staticClass: "w-full",
              attrs: {
                label: "Número Resolución",
                maxlength: "10",
                name: "numeroResolucion",
                min: "0"
              },
              model: {
                value: _vm.datos.numeroResolucion,
                callback: function($$v) {
                  _vm.$set(_vm.datos, "numeroResolucion", $$v)
                },
                expression: "datos.numeroResolucion"
              }
            }),
            _vm.getError("numeroResolucion")
              ? _c(
                  "span",
                  { staticClass: "text-danger text-sm form-error-message" },
                  [_vm._v("Número de resolución obligatorio")]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _c("div", { staticClass: "vx-row" }, [
        _c(
          "div",
          { staticClass: "vx-col md:w-1/2 mt-3" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|alpha_spaces",
                  expression: "'required|alpha_spaces'"
                }
              ],
              staticClass: "w-full",
              attrs: { label: "Razón Social", maxlength: "100", name: "razon" },
              model: {
                value: _vm.datos.razon,
                callback: function($$v) {
                  _vm.$set(_vm.datos, "razon", $$v)
                },
                expression: "datos.razon"
              }
            }),
            _vm.getError("razon")
              ? _c(
                  "span",
                  { staticClass: "text-danger text-sm form-error-message" },
                  [_vm._v("Razón Social es obligatoria")]
                )
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "vx-col md:w-1/2 mt-3" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|alpha_spaces",
                  expression: "'required|alpha_spaces'"
                }
              ],
              staticClass: "w-full",
              attrs: {
                label: "Nombre de fantasía",
                maxlength: "100",
                name: "fantasia"
              },
              model: {
                value: _vm.datos.fantasia,
                callback: function($$v) {
                  _vm.$set(_vm.datos, "fantasia", $$v)
                },
                expression: "datos.fantasia"
              }
            }),
            _vm.getError("fantasia")
              ? _c(
                  "span",
                  { staticClass: "text-danger text-sm form-error-message" },
                  [_vm._v("Nombre de fantasía es obligatorio")]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _c("div", { staticClass: "vx-row mt-8" }, [
        _c(
          "div",
          { staticClass: "vx-col w-1/4" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|validaRut",
                  expression: "'required|validaRut'"
                }
              ],
              staticClass: "w-full",
              attrs: {
                label: "RUT Representante Legal",
                maxlength: "10",
                name: "rutRepLegal"
              },
              model: {
                value: _vm.datos.rutRepLegal,
                callback: function($$v) {
                  _vm.$set(_vm.datos, "rutRepLegal", $$v)
                },
                expression: "datos.rutRepLegal"
              }
            }),
            _vm.getError("rutRepLegal") == "required"
              ? _c(
                  "span",
                  { staticClass: "text-danger text-sm form-error-message" },
                  [_vm._v("RUT es obligatorio")]
                )
              : _vm._e(),
            _vm.getError("rutRepLegal") == "rut"
              ? _c(
                  "span",
                  { staticClass: "text-danger text-sm form-error-message" },
                  [_vm._v("Formato de RUT incorrecto")]
                )
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "vx-col md:w-1/2" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|alpha_spaces",
                  expression: "'required|alpha_spaces'"
                }
              ],
              staticClass: "w-full",
              attrs: {
                label: "Nombre Representante Legal",
                maxlength: "100",
                name: "nombreRepLegal"
              },
              model: {
                value: _vm.datos.nombreRepLegal,
                callback: function($$v) {
                  _vm.$set(_vm.datos, "nombreRepLegal", $$v)
                },
                expression: "datos.nombreRepLegal"
              }
            }),
            _vm.getError("nombreRepLegal")
              ? _c(
                  "span",
                  { staticClass: "text-danger text-sm form-error-message" },
                  [_vm._v("Represenante Legal es obligatoria")]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _c("div", { staticClass: "vx-row mt-8 mb-8" }, [
        _c(
          "div",
          { staticClass: "vx-col" },
          [
            _c(
              "vs-button",
              {
                attrs: { color: "primary", type: "filled" },
                on: { click: _vm.validarEmpresa }
              },
              [_vm._v("Aceptar")]
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }